<template>
  <section>
    <template v-if="showLoader">
      <v-row>
        <v-col
          cols="12"
          md="4"
          lg="4"
          xl="4"
          v-for="n in 3"
          :key="`card-loader-${n}`"
        >
          <v-skeleton-loader
            class="mb-6"
            type="card-avatar, article"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </template>
    <template v-if="courses != null && showLoader == false">
      <div class="courses">
        <v-row>
          <template v-for="item of courses">
            <v-col
              cols="12"
              sm="6"
              lg="4"
              xl="3"
              class="pr-5"
              :key="`cours_${item._id}`"
            >
              <v-hover v-slot:default="{ hover }">
                <v-card
                  class="recCourseCustomCard hoverable card-growable"
                  elevation="0"
                  ripple=""
                  @click="navigate(item)"
                >
                  <v-img
                    class="recCourseImage"
                    max-width="100%"
                    width="auto"
                    :src="item.image"
                    :lazy-src="item.image"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-sheet
                          width="100%"
                          height="100%"
                          color="grey lighten-2"
                          class="d-flex justify-center"
                        >
                          <v-icon x-large color="grey lighten-1"
                            >mdi mdi-image-area</v-icon
                          >
                        </v-sheet>
                      </v-row>
                    </template>
                  </v-img>
                  <v-row>
                    <v-col>
                      <div
                        :style="{
                          color: `${$themeColor}`,
                          fontSize: `13px`,
                          fontWeight: `500`,
                          marginTop: `8px`,
                          marginBottom: `8px`,
                        }"
                        v-text="item.categories[0].title"
                      ></div>
                      <div class="myCourseTitle">{{ item.title }}</div>
                      <div class="recInstructor">
                        {{ item.owner_by_students[0]._id.displayName }}
                      </div>
                      <div class="d-flex" style="align-items: center">
                        <div>
                          <v-rating
                            half-increments
                            half-icon="fas fa-star-half-alt"
                            background-color="grey"
                            color="amber"
                            readonly
                            dense
                            x-small
                            :value="item.rating"
                          ></v-rating>
                        </div>
                        <div class="ml-2 flex-grow-1">
                          <p class="mt-1 mb-0 body-2">{{ item.rating }}</p>
                        </div>
                        <v-spacer></v-spacer>
                        <div class="ml-2 flex-grow-1 text-end">
                          <p
                            v-if="item.bundle.length"
                            class="mb-0 subtitle-1 font-weight-black"
                          >
                            ฿{{
                              item.bundle.length
                                ? numberWithCommas(item.bundle[0].price)
                                : 0
                            }}
                          </p>
                          <p v-else class="mb-0 subtitle-1 font-weight-black">
                            Free
                          </p>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-hover>
            </v-col>
          </template>
          <template v-if="courses.length == 0">
            <v-col cols="12">
              <v-alert text type="info" prominent icon="far fa-sad-tear">
                <div class="display-1">Oops !</div>
                <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>
                <p>We don't have course to display</p>
              </v-alert>
            </v-col>
          </template>
        </v-row>
      </div>
    </template>
  </section>
</template>

<script>
function compare(a, b) {
  if (a.price < b.price) {
    return -1;
  }
  if (a.price > b.price) {
    return 1;
  }
  return 0;
}
export default {
  name: "new_course_renderer",
  props: ["courses", "itemsPerPage", "showLoader", "page"],
  data: () => ({
    currentPage: 1,
    defaultItemsPerPage: 12,
  }),
  watch: {},
  computed: {
    itemsPerPageProp() {
      if (this.itemsPerPage != null) {
        return this.itemsPerPage;
      } else {
        return this.defaultItemsPerPage;
      }
    },
    totalPage() {
      if (this.courses != null) {
        return this.courses.length;
      }
      return 1;
    },
    totalVisible() {
      if (this.$vuetify.breakpoint.mdAndDown) {
        return 5;
      } else {
        return 10;
      }
    },
  },
  mounted() {
    this.currentPage = parseInt(this.page);
    this.fetchBundle();
  },
  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    fetchBundle() {
      var sortable = [];
      this.content.body.forEach((element) => {
        if (element.bundle.length) {
          sortable = element.bundle.sort(compare);
        } else {
          // no bundle
        }
      });
      console.log(sortable);
    },
    onChangePage(val) {
      let nextPgae = this.currentPage + val;
      nextPgae = nextPgae < 1 ? 1 : nextPgae;
      this.$emit("update:page", nextPgae);
    },
    navigate(item) {
      this.$router.push({
        name: "course_detail",
        params: {
          id: item._id,
        },
      });
    },
  },
};
</script>
<style scoped>
.recCourseCustomCard {
  border-radius: 4px;
  border: solid 1px #dcdcdc;
  background-color: #ffffff;
  padding: 15px 15px 15px 15px;
}

.myCourseCatagory {
  font-size: 13px;
  font-weight: 500;
  color: #4a90e2;
  margin-top: 8px;
  margin-bottom: 8px;
}

.myCourseTitle {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.38;
  color: #4a4a4a;

  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* min-height: 43px;
  max-height: 43px; */
}

.recCourseImage {
  width: 100%;
  height: 200px;
}

.recInstructor {
  font-size: 14px;
  line-height: 1.57;
  color: #9b9b9b;
  margin-top: 8px;
  margin-bottom: 8px;
}
.v-card > *:first-child:not(.v-btn):not(.v-chip) {
  border-top-left-radius: unset;
  border-top-right-radius: unset;
}
</style>